module.exports = __webpack_public_path__ + "img/cashback.921a3ce2.png";